import {
  buildDefaultLocalMapTranslationKey,
  IShow,
  LocalMapType,
} from "@evennt-tech/api-v2-core";
import { UseTranslateResult } from "@tolgee/react";
import { ENV_KEY_PREFIX } from "tools/localization/envKeyPrefix";

const localizeStandWallLength = (
  show: Pick<IShow, "localMap"> | null | undefined,
  t: UseTranslateResult["t"]
) => {
  const translationKey =
    show?.localMap?.standWallLengthLocalMap?.translationKey ||
    buildDefaultLocalMapTranslationKey(
      ENV_KEY_PREFIX,
      LocalMapType.StandWallLength
    );

  return t(translationKey, { count: 1 });
};

export default localizeStandWallLength;
